<template>
    <div class="search-assets">
        <div class="search-assets__content">
            <div class="search-assets__head">
                <h3>Отображение общих активов в</h3>
                <button @click="$store.commit('changeSearchAssets', false)">
                    <img src="@/assets/images/close-circle.svg" alt="">
                </button>
            </div>
            <div class="search-assets__inp">
                <button>
                    <img src="@/assets/images/search-icon.svg" alt="">
                </button>
                <input type="text" placeholder="Поиск">
            </div>
            <ul class="search-assets__list">
                <li v-for="i in 16" :key="i">
                    USD
                    <span>$</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Search Asset'
}
</script>

<style>

</style>